import styled from 'styled-components';
import { Input } from 'antd';

/* eslint import/prefer-default-export:0 */
export const FitWidthInput = styled(Input)`
  width: auto;
`;
